import { Component, h, Prop, Host } from '@stencil/core';
import { scrollWindowTo } from './../../../utils/utils';
import state from './../../../state/store';

@Component({
  tag: 'afs-link',
  styleUrl: 'afs-link.css',
  scoped: false,
})
export class AfsLink {

  @Prop() href : string;
  @Prop() target : string = "_blank";
  @Prop() rel : string = "noreferrer";
  @Prop() smoothScrollOffset : number = 0;
  @Prop() color : string = 'var(--afs-link-color)';
  @Prop() shadowTarget : string;
  @Prop() disabled : boolean = false;

  private scrollToTarget(e : MouseEvent) {
    e.preventDefault();
    const target = (e.currentTarget as HTMLElement).getAttribute('href');
    const targetEl = this.shadowTarget ? document.querySelector(this.shadowTarget).shadowRoot.querySelector(target) : document.querySelector(target);
    if (!targetEl) {
      console.warn(`Element "${target}" does not exist in the DOM.`);
      return;
    };

    const targetScrollTop = targetEl.getBoundingClientRect().top;
    scrollWindowTo(targetScrollTop, -state.navHeight + this.smoothScrollOffset);
  }

  render() {
    return (
      <Host style={{color: this.color}} >
        <a 
          href={this.href} 
          target={this.target} 
          rel={this.rel} 
          onClick={ this.disabled && (e => e.preventDefault()) || this.href && this.href.charAt(0) === '#' && this.href.charAt(1) !== "" && (e => {this.scrollToTarget(e)}) }
          data-disabled={this.disabled.toString()}
        ><slot></slot></a>
      </Host>
    )
  }
}
